import { isLocalUrl } from '../helpers/helpers';

export default function rotatingCorpMembers() {
  const widgetName = 'rotatingCorpMembers';
  const widgetOpts = rotatingCorpMembersOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomRotatingMembers(data.items);
        startRotation(widgetName);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomRotatingMembers(widgetData) {
    const $corpSection = $widget.find('.card-widget-item');
    const { Title, Description, URL } = widgetData[0];
    let urlAttribute = isLocalUrl(URL) ? '' : 'target="_blank"';

    $corpSection.replaceWith(`
      <div class="corporate-members-wrapper">
        <h3 class="corp-title">${Title}</h3>
        <div class="corp-items"></div>
      </div>
      <div class="btn-container">
        ${URL ? `<a href="${URL}" class="button" ${urlAttribute}>More</a>` : ''}
      </div>
  `);

    const $itemsContainer = $('.corporate-members-wrapper .corp-items');
    const memberCorp = Description.split(',')
      .filter(Boolean)
      .map((s) => s.trim());

    for (let round = 0; round < 2; round++) {
      for (const corp of memberCorp) {
        $itemsContainer.append(`
        <div class='member-name'>
          <span class='star-bullet'></span>
          <span class="member-label">${corp}</span>
        </div>
      `);
      }
    }

    updateMarqueeDuration($itemsContainer[0]);

    $(globalThis).on('resize', function () {
      updateMarqueeDuration($itemsContainer[0]);
    });
  }

  function updateMarqueeDuration($container) {
    const contentHeight = $container.scrollHeight / 2;
    let speed = 20;
    const duration = contentHeight / speed;
    $($container).css('animation-duration', `${duration}s`);
  }

  function startRotation(widget) {
    const sliderToObserve = $(`#${widget} .corporate-members-wrapper`).get(0);
    if (sliderToObserve) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              $(`#${widget} .corp-items`).addClass('animate');
            } else {
              $(`#${widget} .corp-items`).removeClass('animate');
            }
          }
        },
        { threshold: 0.3 },
      );

      observer.observe(sliderToObserve);
    }
  }
}
